// Cal.com embed configuration.
//
// `VITE_CAL_LINK` is the full Cal.com booking link for the Dash discovery call,
// in the format `<username>/<event-type-slug>` (e.g. "noahlisk/dash-demo").
//
// Set this in Vercel project env vars (Production + Preview) so it ships with
// the build. If not set, we fall back to a known-bad placeholder that logs a
// warning in dev — this makes the misconfiguration loud instead of silent.
const FALLBACK = "MISSING_VITE_CAL_LINK/dash-demo";

export const CAL_LINK: string =
  (import.meta.env.VITE_CAL_LINK as string | undefined)?.trim() || FALLBACK;

export const CAL_NAMESPACE = "dash-demo";

if (import.meta.env.DEV && CAL_LINK === FALLBACK) {
  // eslint-disable-next-line no-console
  console.warn(
    "[Dash] VITE_CAL_LINK is not set. Book-a-demo buttons will not open a real Cal.com link.",
  );
}
